import { DESKTOP } from 'sonder/constants'

const classPreload = 'preload'

export const PRELOAD_TIME_PAGELOAD = 800

/**
 * Adds and removes a preload class on page load, and window resize.
 */
class PreloadClassHandler {
    constructor() {
        this.resizeTimer = 0
    }

    init() {
        if (window.innerWidth >= DESKTOP) {
            window.addEventListener('resize', () => {
                document.body.classList.add(classPreload)

                clearTimeout(this.resizeTimer)
                this.resizeTimer = setTimeout(() => {
                    document.body.classList.remove(classPreload)
                }, 400)
            })
        }

        window.addEventListener('load', function () {
            this.resizeTimer = setTimeout(() => {
                document.body.classList.remove(classPreload)
            }, PRELOAD_TIME_PAGELOAD)
        })
    }
}

export default new PreloadClassHandler() // return singleton instance
